import React from "react";
import Link from "next/link";
import NextImage from "@/components/global/NextImage";
import { validateImgSrc } from "@/utils/global";

const MenuBanner = ({ type, url, image, className }) => {
  const choseUrlHandler = (type) => {
    let hrefURL = "";
    if (type === "url") {
      hrefURL = url;
    } else if (type === "product") {
      hrefURL = `/product/${url}`;
    } else {
      hrefURL = `/cp/${url}`;
    }

    return hrefURL;
  };

  return (
    <Link
      prefetch={false}
      href={choseUrlHandler(type).replace("//", "/")}
      className={`relative  ${className}`}
    >
      <NextImage
        src={validateImgSrc(
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}${
            image?.startsWith("/media/") ? image?.replace("/media", "") : image
          }`
        )}
        className="object-cover rounded-md"
        fill
        alt="Banner Img !"
      />
    </Link>
  );
};

export default MenuBanner;
